import { palette, rem } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const ItemWithLabelWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: start;
	max-width: 800px;
	&&.disabled {
		pointer-events: none;
		opacity: 0.5;
	}
`;

export const Anchor = styled.div<{ linkStyling?: boolean }>`
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 22px;
	word-wrap: break-word;
	padding-top: ${rem(2)};
	margin-bottom: ${rem(8)};
	color: ${({ linkStyling }) =>
		linkStyling ? palette?.primary?.dark : '#252f33'};
	text-decoration: ${({ linkStyling }) =>
		(!linkStyling && 'none') || 'underline'};
	cursor: pointer;
`;

export const Label = styled.h5`
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	color: rgba(0, 0, 0, 0.54);
	margin-top: 0.5rem;
	margin-bottom: 0;
`;

export const AnchorIcon = styled.div`
	display: flex;
	margin-top: -2px;
	cursor: pointer;
`;

export const AnchorWrapper = styled.div`
	font-size: 12px;
`;
